/**
 *
 */
import * as AppConfig from './appconfig'
import * as Comments from './comments'
import * as InitialState from './initialstate'
import Loader from './loader'
import Collaboration from './collaboration'
import Toast from './toast'
import * as WhatsNew from './whatsnew'

/** @namespace OCP */
export default {
	AppConfig,
	Collaboration,
	Comments,
	InitialState,
	Loader,
	Toast,
	WhatsNew
};
